import { useFeatureFlags } from '@brightdrop/feature-flags-client';

import { SHOP_ADD_ONS_FLAG } from '~/common/models/featureFlags.model';
import { PlanManagementTab } from '~/common/models/plans.model';

type UseShopAddOnsPlanManagementConfigResult = {
  isShopAddOnsEnabled: boolean;
  defaultPlanManagementTab: PlanManagementTab;
};

/**
 * Gate for the Shop Add-Ons milestone (SDPCPLT-3435) Plan & Billing surfaces:
 * the device-first Video Telematics tables, the fleet-adapter renderer, and the
 * device-centric pricing / enroll copy. When off, Plan Details renders today's
 * vehicle-only columns and "/vehicle" copy.
 */
export const useShopAddOnsPlanManagementConfig =
  (): UseShopAddOnsPlanManagementConfigResult => {
    const { getFlag } = useFeatureFlags();

    const isShopAddOnsEnabled = Boolean(getFlag(SHOP_ADD_ONS_FLAG));

    return {
      isShopAddOnsEnabled,
      defaultPlanManagementTab: isShopAddOnsEnabled
        ? PlanManagementTab.ONSTAR_PLANS
        : PlanManagementTab.ACTIVE,
    };
  };
